import React from 'react';
import Chart from "react-apexcharts";
import global from '../../../common/utility/global';

export default function GraficoControlMoneda(props) {


  const options = {
    series: props.series,
    title: {
      text: 'Vendedor * PEN - USD ',
      align: 'center',
      style: {
        fontSize: "18px",
        fontWeight: "bold",
        fontFamily: undefined,
        color: "#263238",
      },
    },
    chart: {
      type: 'bar',
      height: 400,
      stacked: true,
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 10,
        columnWidth: '30%', // Controla el ancho de cada barra
        borderRadiusApplication: 'around', // 'around', 'end'
        borderRadiusWhenStacked: 'all', // 'all', 'last'
      }
    },
    xaxis: {
      categories: props.vendedores,
    },
    fill: { opacity: 1 },
    colors: [
      '#FF5722',
      '#BF360C',
    ],
    dataLabels: {
      enabled:true,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          const formattedValue = new Intl.NumberFormat("es-US",{
            minimumFractionDigits:2,
            maximumFractionDigits:2
          }).format(val);

          return formattedValue + ' ';
        },
      },
    },
  };

    ;
  return (
    <div id="chart">
      <Chart options={options} series={options.series} type="bar" height={350} />
    </div>
  );
}